export { Text } from './Text';
export { TextAlign, TextColor, TextStyle } from './Text.types';
export type { TextProps } from './Text.types';
